import {
    GET_DATA,
    SET_LOADING,
    GET_DATA_ERROR,
    GET_USER_DATA,
    GET_USER_DATA_ERROR,
    SET_FILTER,
    GET_INDICATORS_ERROR,
    CLEAR_DATA,
    CLEAR_DATA_ERROR,
    HIDE_DATA,
    SHOW_DATA,
    CLEAR_INDICATORS,
    GET_LABELS_ERROR,
    GET_LABELS
    ,
    SET_ACTIVE_PLOT,
    SET_ACTIVE_PLOT_ERROR,
    SET_PREVIOUS_DATA_ERROR,
    DELETE_PREVIOUS_DATA_ERROR,
    DELETE_PREVIOUS_DATA,
    SET_PREVIOUS_DATA,
    SET_STATISTICS,
    SET_STATISTICS_ERROR,
    DELETE_STATISTIC,
    DELETE_STATISTIC_ERROR,
    REMOVE_PLOT_POINT,
    HIDE_ALL_POINTS, SHOW_ALL_POINTS,
    REMOVE_USER_PLOT_POINT,
    GET_YEARLY_DATA,
    GET_YEARLY_DATA_ERROR

} from "./actions";

export const setLoading = () => {
    return {
        type: SET_LOADING,
    };
};


export const getData = (indicator, filter,startDate=new Date(2021, 0, 1),endDate=new Date(2021, 11, 31)) => async (dispatch) => {
    try {
        setLoading();
        delete filter.undefined;
        if(startDate._isAMomentObject)
            startDate=startDate.toDate();
        if(endDate._isAMomentObject)
            endDate=endDate.toDate();
        let requestData = {};
        Object.assign(requestData,filter);
        indicator.map(i => {
                if (!requestData.hasOwnProperty(i)) {
                    Object.assign(requestData, {[i]: 'none'});
                }
            }
        );
        requestData.startDate = startDate.getTime();
        requestData.endDate = endDate.getTime();
        let url = process.env.REACT_APP_GET_DATA_POINTS_URL + new URLSearchParams({
            requestData:JSON.stringify(requestData)
        })
        const res = await fetch(url,{
            headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }


        );
        const data = await res.json();
        dispatch({
            type: GET_DATA,
            payload: data,
        });
    } catch (err) {
        dispatch({
            type: GET_DATA_ERROR,
            payload: err,
        });
    }


};


export const getUserData = (indicator,startDate=new Date(2021, 0, 1),endDate=new Date(2021, 11, 31),opk="507-1310",filter) => async (dispatch) => {
    try {

        setLoading();
            if(startDate._isAMomentObject)
                startDate=startDate.toDate();
            if(endDate._isAMomentObject)
                endDate=endDate.toDate();
        // todo swap to axios add parms set env ip make axios global
        let requestData = {};
        Object.assign(requestData,filter);
        indicator.map(i => {
                if (!requestData.hasOwnProperty(i)) {
                    Object.assign(requestData, {[i]: 'none'});
                }
            }
        );
        let url = process.env.REACT_APP_GET_USER_DATA_POINTS_URL + new URLSearchParams({
            startDate: startDate.getTime(),
            endDate: endDate.getTime(),
            opk: opk,
            requestData:JSON.stringify(requestData),

        });
        const res = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }
        );
        const data = await res.json();
        dispatch({
            type: GET_USER_DATA,
            payload: data,
        });
    } catch (err) {
        console.error(err);
        dispatch({
            type: GET_USER_DATA_ERROR,
            payload: err,
        });
    }


};

export const clearData = () => async (dispatch) => {
    try {

        dispatch({
            type: CLEAR_DATA,
        });
    } catch (err) {
        dispatch({
            type: CLEAR_DATA_ERROR,
        });
    }

};

export const hideDataPoint = (data,name) => async (dispatch) => {

    dispatch({
        type: HIDE_DATA,
        payload: {name:name,
                  data:data  }
    });


};

export const showDataPoint = (data,name) => async (dispatch) => {

    dispatch({
        type: SHOW_DATA,
        payload: {name:name,
                  data:data  }
    });


};
export const getLabels = () => async (dispatch) => {
    try {
        setLoading();
        // todo swap to axios add parms set env ip make axios global
        const res = await fetch(process.env.REACT_APP_GET_LABELS);
        const data = await res.json();
        dispatch({
            type: GET_LABELS,
            payload: data,
        });


    } catch (err) {
        dispatch({
            type: GET_LABELS_ERROR,
            payload: err,
        });
    }


};


export const setActivePlot = (name) => async (dispatch) => {
    try {

        dispatch({
            type: SET_ACTIVE_PLOT,
            payload: name,
        });

    } catch (err) {
        dispatch({
            type: SET_ACTIVE_PLOT_ERROR,
            payload: err,
        });
    }


};

export const setPreviousData = (name) => async (dispatch) => {
    try {

        dispatch({
            type: SET_PREVIOUS_DATA,
            payload: name,
        });

    } catch (err) {
        dispatch({
            type: SET_PREVIOUS_DATA_ERROR,
            payload: err,
        });
    }


};

export const deletePreviousData = (name) => async (dispatch) => {
    try {

        dispatch({
            type:DELETE_PREVIOUS_DATA,
            payload: name,
        });

    } catch (err) {
        dispatch({
            type: DELETE_PREVIOUS_DATA_ERROR,
            payload: err,
        });
    }


};

export const setStatics = (stats) => async (dispatch) => {
    try {

        dispatch({
            type: SET_STATISTICS,
            payload: stats,
        });

    } catch (err) {
        dispatch({
            type: SET_STATISTICS_ERROR,
            payload: err,
        });
    }


};

export const deleteStatics = (stats) => async (dispatch) => {
    try {

        dispatch({
            type:DELETE_STATISTIC,
            payload: stats,
        });

    } catch (err) {
        dispatch({
            type: DELETE_STATISTIC_ERROR,
            payload: err,
        });
    }


};


export const removePlotPoint = (plotPoint) => async (dispatch) => {

        dispatch({
            type:REMOVE_PLOT_POINT,
            payload: plotPoint,
        });



};


export const hideAllDataPoint = (data,name) => async (dispatch) => {

    dispatch({
        type: HIDE_ALL_POINTS,
        payload: {name:name,
                  data:data  }
    });


};

export const showAllDataPoint = (name) => async (dispatch) => {

    dispatch({
        type: SHOW_ALL_POINTS,
        payload: {name:name}
    });


};




export const removeUserPlotPoint = (plotPoint) => async (dispatch) => {

        dispatch({
            type:REMOVE_USER_PLOT_POINT,
            payload: plotPoint,
        });



};
export const getYearlyUserData = (indicator,opk="507-1310",startDate=new Date(2021, 0, 1),endDate=new Date(2021, 11, 31),) => async (dispatch) => {
    try {

        setLoading();
            if(startDate._isAMomentObject)
                startDate=startDate.toDate();
            if(endDate._isAMomentObject)
                endDate=endDate.toDate();
        // todo swap to axios add parms set env ip make axios global
        let url = process.env.REACT_APP_GET_YEARLY_DATA + new URLSearchParams({
            wskaznik: indicator,
            startDate: startDate.getTime(),
            endDate: endDate.getTime(),
            opk: opk,

        });
        const res = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
            }
        );
        const data = await res.json();
        dispatch({
            type: GET_YEARLY_DATA,
            payload: data,
        });
    } catch (err) {
        console.error(err);
        dispatch({
            type: GET_YEARLY_DATA_ERROR,
            payload: err,
        });
    }


};